export enum Routes {
    Templates = "templates",
    Screens = "screens",
    Config = "config",
    Auth = "auth",
    TenantSelection = "tenant-selection",
    CreateTenant = "create-tenant",
    Tenant = "tenant",
    ScreenPairing = "screens/pair",
    Users = "users",
}
